module.exports = __webpack_public_path__ + "static/media/hood-cloak.3542a428.svg";